import React from 'react'

const PaymentLogoImg = () => {
  return (
      <>
          {/* ============= Smart Card Payment logo =========== */}
          <section>
              <div className="container">
                  <div className="payment-logo">
                      <img src="/img/home/payment.png" alt="" />
                  </div>
              </div>
          </section>
      </>
  )
}

export default PaymentLogoImg